import React from "react";
import AdminShell from "../components/AdminShell.jsx";

export default function AdminConsultasIndex() {
  return (
    <AdminShell>
      <h3 className="mb-3">Consultas</h3>
      <p>Listado de consultas (placeholder).</p>
    </AdminShell>
  );
}
